import React from 'react';
import { connect } from 'react-redux';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import Combobox from 'infrastructure/js/components/controls/Combobox/combobox.js';
import {round} from '../../../utils/assetHelper';
import InputSection from 'infrastructure/js/components/Dialog/InputSection/inputSection';
import { reduxForm, formValueSelector } from 'redux-form';
import {getEnumValue, enumTypes} from '../../../utils/enumHelper';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import SubRollListItem from '../../Common/Controls/AddRemoveList/AddRemoveListItem/SubRollListItem/subRollListItem';
import UnitHelper, { unitTypes } from 'infrastructure/js/utils/uomHelper';
import MaterialHelper from '../../../utils/materialHelper';
import  * as dialogHelper  from 'infrastructure/js/components/Dialog/dialogHelper';
import EntitiesMultiSelect from '../../Common/Controls/EntitiesMultiSelect/entitiesMultiSelect';
import {EntityPropertyTypes} from '../../../enums/entityPropertyTypes';
import {FetchEntitiesFilters} from '../../../enums/fetchEntitiesFilters';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import List from 'infrastructure/js/components/List/list';
import NameValuePairs from '../../Common/NameValuePairs/nameValuePairs';
import RadioButton from 'infrastructure/js/components/controls/RadioButton/radioButton';

require('./createSubRollsDialog.scss');


function  getCutByOptions() {
  return [
    {value: 'LENGTH', label: 'Length'},
    {value: 'WIDTH', label: 'Width'},
  ]
}

class CreateSubRollsDialog extends React.PureComponent {
  constructor (props) {
    super(props);
    this.activeStatuses = [getEnumValue(enumTypes.ASSET_STATUS)('ACTIVE'), getEnumValue(enumTypes.ASSET_STATUS)('TOOL_MANUFACTURING')];
    this.archiveStatuses = [getEnumValue(enumTypes.ASSET_STATUS)('CONSUMED'), getEnumValue(enumTypes.ASSET_STATUS)('DISQUALIFIED'), getEnumValue(enumTypes.ASSET_STATUS)('SHIPPED')];
    this.labels = createLabelHelper('mat.locationpage.view.cutting.createsubrollsdialog.');
    this.dialogLabels = createLabelHelper('mat.dialog.');
    this.archiveStatuslabels = createLabelHelper('mat.archive.status.');
    this.activeStatuslabels = createLabelHelper('mat.active.status.');

    let preselectedAssets = this.props.sData.get('preselectedAssets');
    this.currentAsset =  (preselectedAssets.size === 1) ? preselectedAssets.get(0) : null;
    this.subRollsStatuses = this.getStatuses();

    //add the first empty list item on opening
    let initialList = [];
    initialList.push(null);

    this.state = {
      subRolls: initialList,
      cutBy: PermissionManager.isWeightSupported() ? 'WEIGHT' : 'LENGTH',
      parentQuantity: 0,
      remainQuantity: 0,
      errorMessage: '',
      printPDFLabels: false,
    };

    this.fetchConfig = {
      entityType: EntityPropertyTypes.WO_BUSINESS_ID,
      filter: [FetchEntitiesFilters.ACTIVE],
      action: this.props.fetchEntitiesActions.fetchEntities,
    };

    if (this.currentAsset && this.currentAsset.projectId) {
      this.fetchConfig.searchBy = {
        wo: [{
          objectName: 'projectId',
          values: [this.currentAsset.projectId]
        }]
      };
    }

    this.footerCheckbox = {
      text: this.labels.get('subrollsstatus.printPDFLabels'),
      action: (value) => { this.setState({ printPDFLabels: value }); }
    };
  }

  getParentQuantity = () => {
    const units = this.getCutByUnits();
    const fieldName = this.getCutByFieldName();

    return UnitHelper.serverValueToUserValue(units, this.currentAsset[fieldName], 2 ) ?? 0;
  }

  componentDidMount() {
    let initialValues = {
      subRolls: [{}],
      cutBy: PermissionManager.isWeightSupported() ? null : 'LENGTH',
    };

    this.props.initialize(initialValues);

    const quantity = this.getParentQuantity();
    this.setState({
      parentQuantity: quantity,
      remainQuantity: quantity,
    });
  }

  getStatuses = () => {
    let options = [];
    options.push({value: 0, label: this.labels.get('subrollsstatus.active'), isDisabled: true});
    this.activeStatuses.forEach((status) => {
      options.push({value: status, label: this.activeStatuslabels.get(status.toLowerCase())} );
    });

    options.push({value: 0, label: this.labels.get('subrollsstatus.archive'), isDisabled: true});
    this.archiveStatuses.forEach((status) => {
      options.push({value: status, label: this.archiveStatuslabels.get(status.toLowerCase())} );
    });

    return options;
  };


  getComponentToRender(props) {
    if (!props || !props.data) {
      return null;
    }
    let option = props.data;
    return <span className={option.isDisabled ? 'sub-rolls-status-title' : 'sub-rolls-status'}>{option.label}</span>
  }

  getDialogButtons() {
    let isLoading = this.props.sData.get('loading');

    let buttonOK = {
      id:'submit',
      text: this.dialogLabels.get('create'),
      bsStyle: 'primary',
      loading: isLoading,
      action:  this.props.handleSubmit(this.onSubmit),
      disabled: (this.state.subRolls.length < 1) ||
                isLoading ||
                this.props.sData.get('hasError') ||
                (this.props.sData.get('showIgnoreValidationCheckbox') && !this.props.sData.get('isIgnoreValidationWarnings'))
    };

    let buttonCancel = {
      id:'cancel',
      text: this.dialogLabels.get('cancel'),
      action: this.onHide
    };

    return { left: [buttonCancel], right: [buttonOK] };
  }

  getValidationError = () => {
    if (this.state.errorMessage) {
      return (
        <span className="error-message">
        <span className="pl pl-warning-icon error error-icon"/>
          {this.state.errorMessage}
        </span>
      )
    }
  };

  onHide = () => {
    this.props.actions.hide();
  };

  validateOnSubmit = (data) => {
    let quantitySum = data.subRolls.reduce((previous, current) => {
      return previous + (+(current.quantity));
    }, 0);

    return (quantitySum > this.state.parentQuantity) ? this.labels.get('footer.errormessage') : '';
  };

  onSubmit = (data) => {

    let errorMessage = this.validateOnSubmit(data);
    this.setState({errorMessage: errorMessage});
    if (errorMessage) {
      return;
    }

    let newData = {};
    if (data.workOrder) {
      newData.workOrder = data.workOrder.label;
    }

    if (data.subRollsStatus) {
      newData.subRollsStatus = data.subRollsStatus.value;
    }

    if (data.subRolls) {
      const units = this.getCutByUnits();
      const fieldName = this.getCutByFieldName(true);

      newData.subRolls = data.subRolls.map((item) => {
          const quantity = +(item.quantity);
          return {businessId: item.subRoll, [fieldName]: UnitHelper.userValueToServerValue(units, quantity, 2)}
      });
    }

    newData.ignoreValidationWarnings = (this.props.sData.get('showIgnoreValidationCheckbox') && data.footerValidationCheckbox) ?
                                        data.footerValidationCheckbox : false;

    newData.parentRollId = this.currentAsset.id;

    this.props.actions.submit(newData,  this.state.cutBy, this.props.reloadParentComponent, this.state.printPDFLabels);

  };

  getFooterValidationCheckBox = () => {
    return this.props.sData.get('showIgnoreValidationCheckbox') ?
      {label: this.dialogLabels.get('ignorewarnings'),onChange: this.onFooterValidationChange} : null;
  };

  onFooterValidationChange = (value) => {
    this.props.actions.toggleIgnoreValidationWarningsCheckbox(value);
  };

  onGenerateClickCallback = (index) => {
    this.props.actions.generateSubRollId(this.currentAsset.id).then(
      (response) => {
        let name = 'subRolls[' + index + '].subRoll';
        this.props.change( name, response.data);
      }
    );
  };

  getRemainQuantity = () => {
    let allRows = this.props.fieldsValues;

    if (allRows) {
      let sum = allRows.reduce((previous, current) => {
        let cutQuantity = current.quantity ?? 0;
        return previous + (+(cutQuantity) );
      }, 0);

      return round(this.state.parentQuantity - sum);
    }
  }

  updateRemainQuantity = () => {
    let remainQuantity = this.getRemainQuantity();
    this.setState({remainQuantity: remainQuantity});
  };

  getMaxCutQuantityByIndex = (index) => {
    let allRows = this.props.fieldsValues;

    if (allRows && allRows.length > index) {
      let quantity = +(allRows[index]?.quantity) || 0;
      return quantity + this.getRemainQuantity();
    }
    return this.state.remainQuantity;
  };

  onQuantityChangedCallback = (value, index) => {
    setTimeout(() => {this.updateRemainQuantity(index)}, 0);
  };

  onRemoveCallback = (index) => {
    let subRolls = [...this.state.subRolls];

    if (index > -1) {
      subRolls.splice(index, 1);
    }

    this.setState({subRolls: subRolls});
    setTimeout(() => {this.updateRemainQuantity()}, 0);
  };

  onAddCallback = () => {
    let subRolls = [...this.state.subRolls];

    subRolls.push(null); //hold index in subRolls for the new added item

    this.setState({subRolls: subRolls});
    setTimeout(() => {this.updateRemainQuantity()}, 0);
  };

  onCutByChange = (value) => {
    this.setState({cutBy: value});
    this.props.change( 'subRolls', [{}]);

    setTimeout(() => {
      let quantity = this.getParentQuantity();
      this.setState({subRolls: [{}], parentQuantity: quantity, remainQuantity: quantity})
    }, 0);
  }


  renderParentRollDetails = () => {
    const {businessId, materialName, materialBusinessId, length = 0, width = 0, weight = 0} = this.currentAsset;

    const rollMaterial = MaterialHelper.getMaterialFullLabel(materialName, materialBusinessId);

    const rollQuantity = PermissionManager.isWeightSupported() ?
      [{label: this.labels.get('weight'), value: `${UnitHelper.serverValueToUserValueWithLabel(unitTypes.WEIGHT, weight, 2)}`}] :
      [
        {label: this.labels.get('length'), value: `${UnitHelper.serverValueToUserValueWithLabel(unitTypes.LENGTH, length,  2)}`},
        {label: this.labels.get('width'), value: `${UnitHelper.serverValueToUserValueWithLabel(unitTypes.WIDTH, width, 2)}`}
      ]

    const rollDetails = [
      {label: this.labels.get('roll'), value: businessId},
      {label: this.labels.get('material'), value: rollMaterial},
      ...rollQuantity
    ]

    return <NameValuePairs items={rollDetails}/>
  };

  listItemRenderer = (data) => {
    let maxQuantity = this.getMaxCutQuantityByIndex(data.index);
    return (
      <SubRollListItem
        {...data}
        onGenerateClickCallback={this.onGenerateClickCallback}
        onQuantityChangedCallback={this.onQuantityChangedCallback}
        labels={this.labels}
        quantityLeft={maxQuantity}

        {...this.props}
      />
    )
  };

  getCutByFieldName = (forSubmit = false) => {
    switch (this.state.cutBy) {
      case 'LENGTH':
        return forSubmit ? 'cutLength' : 'length';
      case 'WIDTH':
        return forSubmit ? 'widthUsed' : 'width';
      case 'WEIGHT':
        return forSubmit ? 'weightUsed' : 'weight';
      default:
        console.error('getCutByFieldName(): unknown cutBy type', this.state.cutBy);
        return '';
    }
  }

  getCutByUnits = () => {
    switch (this.state.cutBy) {
      case 'LENGTH':
        return unitTypes.LENGTH;
      case 'WIDTH':
        return unitTypes.WIDTH;
      case 'WEIGHT':
        return unitTypes.WEIGHT;
      default:
        console.error('getCutByUnits(): unknown cutBy type', this.state.cutBy);
        return '';
    }
  }

  getCutByLabel = () => {
    switch (this.state.cutBy) {
      case 'LENGTH':
        return 'subrollslist.cutLength';
      case 'WIDTH':
        return 'subrollslist.cutWidth';
      case 'WEIGHT':
        return 'subrollslist.weightUsed';
      default:
        console.error('getCutByLabel(): unknown cutBy type', this.state.cutBy);
        return '';
    }
  }

  renderCutByLabel = () => {
    const units = this.getCutByUnits();
    const labelKey = this.getCutByLabel();

    return (
      <div className="column">
        <label className="">{this.labels.get(labelKey)}</label>
        <label className="units">{`(${UnitHelper.getLabelForUnitType(units)})*`}</label>
      </div>
    )
  };

  renderCutByRemain = () => {
    let units = this.getCutByUnits();

    return  (
      <div className="label-with-units-container">
        <label>{this.labels.get('subrollslist.remainQuantity', undefined, { remainQuantity: this.state.remainQuantity } )}</label>
        <label className="units">{`(${UnitHelper.getLabelForUnitType(units)})`}</label>
      </div>
    )
  };

  renderSubRollsList = () => {
    return(
      <div className="sub-rolls-list-container input-section no-margin" >

        <div className="sub-rolls-list-title">
          <label className="column">{this.labels.get('subrollslist.title', '', {subRollsNumber: this.state.subRolls.length}) + '*'}</label>
          {this.renderCutByLabel()}
        </div>

        <List name='subRolls'
                       itemRenderer={this.listItemRenderer}
                       preSelectedItems={this.state.subRolls}
                       onRemoveCallback={this.onRemoveCallback}
                       onAddCallback={this.onAddCallback}
                       maxItemsToOverflow={6}
                       minFieldsCount={1}
                       addButtonLabel={this.labels.get('subrollslist.button.add')}
        />
        {this.renderCutByRemain()}

      </div>
    )
  };


  render() {
    if (!this.currentAsset ) {
      return null;
    }

    let {sData, ...others} = this.props;

    return (
      <div>
        <Dialog
          id='create-sub-rolls-dialog'
          className='create-sub-rolls-dialog'
          sData={this.props.sData}
          show={this.props.sData.get('show')}
          onHide={this.onHide}
          titleText={this.labels.get('header.title') }
          footerCenterText = {this.getValidationError()}
          footerCheckbox={this.footerCheckbox}
          footerValidationCheckbox={this.getFooterValidationCheckBox()}
          footerInformationIcon={dialogHelper.getFooterInformationIcon(this.props.sData, this.dialogLabels)}
          footerButtons ={this.getDialogButtons()}
          onEnterKeyPress={this.props.handleSubmit(this.onSubmit)}
        >

          {this.renderParentRollDetails()}

          <InputSection label={this.labels.get('workorder')} htmlFor="workOrder" className="inline left-side">
            <EntitiesMultiSelect
              id="workOrder"
              name="workOrder"
              entitiesTypes={[getEnumValue(enumTypes.OBJECT_TYPE)('WO')]}
              fetchConfig={this.fetchConfig}
              {...others}
              isMulti={false}
              showEntitiesTypes={false}
              autoFocus={true}
            />

          </InputSection>

          <InputSection label={this.labels.get('subrollsstatus')} htmlFor="subRollsStatus" className="inline right-side">
            <Combobox
              id="subRollsStatus"
              name="subRollsStatus"
              options={this.subRollsStatuses}
              optionRenderer={this.getComponentToRender}
            />
          </InputSection>

          {!PermissionManager.isWeightSupported() && <InputSection label={this.labels.get('cutBy')} htmlFor="cutBy" className="inline left-side">
            <RadioButton id="cutBy" name="cutBy" className="short-textfield"
                         labelsAndValues={getCutByOptions()}
                         onChange={this.onCutByChange}
            />
          </InputSection>}

          {this.renderSubRollsList()}

        </Dialog>
      </div>
    );
  }

}

CreateSubRollsDialog = reduxForm({
    form: 'createSubRollsDialogForm',
    onChange: (values, dispatch, props, previousValues ) => {
      dialogHelper.onFormChangeHandler(values, props, previousValues);
    },
  }
)(CreateSubRollsDialog);

const selector = formValueSelector('createSubRollsDialogForm');

export default CreateSubRollsDialog = connect( state => {
  return {  fieldsValues: selector(state, 'subRolls') }
})( CreateSubRollsDialog );
